import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import router from './router'
import store from './store/index'
import { Swiper, SwiperSlide} from 'vue-awesome-swiper'
Vue.component('swiper', Swiper)
Vue.component('swiper-slide', SwiperSlide)
Vue.config.productionTip = false
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)
import 'lib-flexible'
import './style/common.css'
import './assets/styles/reset.css'
import './assets/styles/style.less'
import 'ant-design-vue/dist/antd.css'
import 'swiper/css/swiper.css'
import './style/theme.less'
// import './assets/menu/iconfont/iconfont.css'
import './Mobile/theme.less'
// 导航守卫
import './common/fuards/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
Vue.use(Antd)

import Directives from './directive/index'
Vue.use(Directives)
Vue.prototype.$title = '汇通数科'



router.beforeEach((to, from, next) => {
   // 如果路由对象中定义了title，则使用定义的title
   if (to.meta && to.meta.title) {
    document.title = '汇通数科-'+to.meta.title
  } else {
    // 否则使用全局title
    document.title = Vue.prototype.$title
  }
  // PC和移动端页面切换菜单后滚到顶部
  window.scrollTo(0, 0)
  next()
})

new Vue({
  router,
  store,
  el: '#app',
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  },
  render: h => h(App)
}).$mount('#app')
